import {
  Badge,
  cn,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "web-design-system";
import { cva } from "class-variance-authority";

const variants = cva("!text-xxs font-semibold uppercase", {
  variants: {
    status: {
      COMPLETED: "bg-tag-green text-tag-green-foreground",
      REJECTED: "bg-tag-red text-tag-red-foreground",
      UNDER_PROCESSING: "bg-tag-orange text-tag-orange-foreground",
      DOWNLOADED: "bg-tag-blue text-tag-blue-foreground",
      IDLE: "bg-tag-grey text-tag-grey-foreground",
      IN_TRANSIT: "bg-tag-yellow text-tag-yellow-foreground",
    } as Record<string, string>,
  },
  defaultVariants: {
    status: "IDLE",
  },
});

export function CobStatusBadge({
  status,
  text,
  title,
}: {
  status: string;
  text?: string;
  title?: string;
}) {
  const badgeText = text || status?.replace("_", " ");

  const content = (
    <Badge className={cn(variants({ status }))} variant="custom">
      {badgeText}
    </Badge>
  );

  if (title) {
    return (
      <Tooltip>
        <TooltipTrigger>{content}</TooltipTrigger>
        <TooltipContent>{title}</TooltipContent>
      </Tooltip>
    );
  }

  return content;
}
